import React from 'react';
import '../assets/css/ProductDetailSkeleton.css';

interface ProductDetailSkeletonProps {
  count?: number;
}

const ProductDetailSkeleton: React.FC<ProductDetailSkeletonProps> = ({ count = 1 }) => {
  return (
    <div className="product-detail-skeleton">
      <div className="product-skeleton-back-button"></div>

      <article className="product-skeleton-article">
        <header className="product-skeleton-header">
          <div className="skeleton-line skeleton-title"></div>
          <div className="skeleton-line skeleton-subtitle"></div>
          <div className="skeleton-line skeleton-subtitle short"></div>
        </header>

        <div className="product-skeleton-content">
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line short"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line short"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
        </div>
      </article>
    </div>
  );
};

export default ProductDetailSkeleton;
